import type { InternalTableSchema } from '../core/schema/types';

/**
 * Extracts all unique action IDs from a normalized schema.
 * Used by DynamicTableV2 to auto-load action domain modules via
 * ActionRegistry.ensureActions().
 */
export function extractActionIds(schema: InternalTableSchema): string[] {
  const ids = new Set<string>();

  for (const action of schema.actions.row) {
    ids.add(action.id);
  }
  for (const action of schema.actions.bulk) {
    ids.add(action.id);
  }
  for (const action of schema.actions.subRow) {
    ids.add(action.id);
  }
  for (const button of schema.actions.toolbar.buttons) {
    ids.add(button.id);
  }
  for (const template of schema.actions.toolbar.templates) {
    for (const action of template.children) {
      ids.add(action.id);
    }
  }

  return [...ids];
}
